import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Subscription } from 'rxjs';
import { IParentEntity } from 'app/shared/interfaces/entity';
import { Router } from '@angular/router';
import { Subject } from '../../../shared/models/subject';
import { Task } from '../../../shared/models/task';
import { TaskService } from '../../../shared/services/task.service';
import {
  ListFilterItem,
  ListSortOrderItem,
} from '../../../shared/services/listSortAndFilterHelpers';
import {
  TaskDialogComponent,
  TaskDialogData,
} from '../../content/tasks/task-dialog/task-dialog.component';
import { AuthService } from 'app/shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'task-widget',
  templateUrl: './task-widget.component.html',
  styleUrls: ['./task-widget.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class TaskWidgetComponent implements OnInit, OnDestroy, AfterViewInit {
  title: string = 'Tasks';
  parent: IParentEntity;
  parentSubject: Subject;
  displayPage = false;
  allowAdd = true;
  allowEdit = false;
  userReadOnly = false;
  onNewTaskClicked: Subscription;
  onApplySortOrder: Subscription;
  onApplyFilter: Subscription;
  onTasksChanged: Subscription;

  appliedSortOrder: ListSortOrderItem | undefined;
  appliedFilter: ListFilterItem | undefined;

  //added empty inputs to remove errors - YA
  @Input() id: Number;
  @Input() subjectId: Number;
  @Input() processTypeId: Number;
  @Input() settings: any;

  @Input() set subject(val: Subject) {
    if (val) {
      this.allowAdd = val && val.isPrimary;
      this.parentSubject = val;
      this.parent = {
        id: this.parentSubject.id,
        uid: this.parentSubject.uid,
        type: 'subject',
        summary: this.parentSubject.summary,
      };
      this.allowEdit = !!(
        this.parent.uid &&
        !val.archived &&
        !this.userReadOnly
      );
    }
  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    public taskService: TaskService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    // this.title = 'Tasks';

    this.appliedFilter = this.taskService.getFilters().find((i) => i.selected);
    this.appliedSortOrder = this.taskService
      .getSortOrders()
      .find((i) => i.selected);
    this.userReadOnly = this.authService.isUserReadOnly();
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.onApplySortOrder = this.taskService.onApplySortOrder.subscribe(
      (taskSortOrder: ListSortOrderItem) => {
        this.appliedSortOrder = taskSortOrder;
      }
    );

    this.onApplyFilter = this.taskService.onApplyFilter.subscribe(
      (taskFilter: ListFilterItem) => {
        this.appliedFilter = taskFilter;
      }
    );

    this.onTasksChanged = this.taskService.onChanged.subscribe(
      (tasks: Task[]) => {
        if (tasks) {
          this.title = 'Tasks ' + (tasks.length > 0 ? '(' + tasks.length + ')' : '');
          this.changeDetectorRef.detectChanges();
        }
      }
    );

    this.onNewTaskClicked = this.taskService.onNewTaskClicked.subscribe(
      (task) => {
        if (!task) {
          task = new Task();
          task.subject = this.parentSubject;
          task.subjectId = this.parentSubject.id;
          if (this.parentSubject.subjectOrganisations.length > 0)
            task.organisationId =
              this.parentSubject.subjectOrganisations[0].organisationId;
        }
        const taskDlgData: TaskDialogData = new TaskDialogData(
          task,
          this.userReadOnly,
          true
        );
        this.dialog
          .open(TaskDialogComponent, {
            data: taskDlgData,
          })
          .afterClosed()
          .subscribe((x) => {
            // force refresh of tasks for current subject
            this.taskService.getTasks();
          });
      }
    );
  }

  ngOnDestroy() {
    this.onNewTaskClicked.unsubscribe();
    this.onApplyFilter.unsubscribe();
    this.onApplySortOrder.unsubscribe();
    this.onTasksChanged.unsubscribe();
  }

  add() {
    this.taskService.onNewTaskClicked.next(undefined);
  }

  displayAsPage(displayPage) {
    this.displayPage = displayPage;
  }

  btnApplySortOrder(sortOrder: ListSortOrderItem) {
    this.taskService.onApplySortOrder.next(sortOrder);
  }

  getSortOrderTooltip(): string {
    if (this.appliedSortOrder) {
      return (
        'Sort by ' +
        this.appliedSortOrder.title +
        ' ' +
        (this.appliedSortOrder.order > 0 ? ' (Ascending)' : ' (Descending)')
      );
    }
    return '';
  }

  btnApplyFilter(filter: ListFilterItem) {
    this.taskService.onApplyFilter.next(filter);
  }

  getFilterTooltip(): string {
    if (this.appliedFilter) {
      return 'Tasks filtered by :' + this.appliedFilter.title;
    }
    return 'Filter Tasks';
  }
}
